var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9545 33.1475H6.59154C3.50381 33.1475 1.00069 30.6444 1.0006 27.5567L1 6.5911C0.999912 3.50324 3.50309 1 6.59094 1H40.1353C43.2232 1 45.7264 3.5017 45.7263 6.58958L45.7265 16.3751M37.34 27.517L40.8543 31.0313L48.5219 23.3634M2.39666 10.7838H44.3287",
    stroke: "#00AC4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTick);
export default __webpack_public_path__ + "static/media/profile-tick.f1854ce9ace213b13be95da3289ebd00.svg";
export { ForwardRef as ReactComponent };